import { createSlice } from "@reduxjs/toolkit";
import { settingsLocalStorageService } from "../services/SettingsLocalStorageService";

export const settings = createSlice({
  name: "settings",
  initialState: {
    showVAT: settingsLocalStorageService.getShowVAT(),
    basketQtySync: $("#AUTO_ADD_TO_CART").val() === "true",
  },
  reducers: {
    setShowVAT: (state, action) => {
      state.showVAT = action.payload;
      return state;
    },
    setBasketQtySync: (state, action) => {
      state.basketQtySync = action.payload;
    },
  },
});

export const { setShowVAT } = settings.actions;
